import Post from "../Post";

import getToken from "../token";

export default function addRating(counselingId, rating, tag, description) {
  return Post("counseling/rating/addRating", {
    token: getToken(),
    counselingId: counselingId,
    rating: rating, //beetwen 0 to 5
    tag: tag,
    description: description,
  });
}
